/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LogRevenueContainer_user$ref: FragmentReference;
export type LogRevenueContainer_user = {|
  +id: string,
  +$refType: LogRevenueContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "LogRevenueContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '222a0becdf70c0d3b5c6cca076be9f6d';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Dashboard/__generated__/LogRevenueContainer_user.graphql.js